import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';

import {
  FETCH_APPOINTMENT_FOR_EDIT_FAILURE,
  FETCH_APPOINTMENT_FOR_EDIT_REQUEST,
  FETCH_APPOINTMENT_FOR_EDIT_SUCCESS,
} from 'booking/constants';

const ATAG = 'fetchAppointment';
const L = logger(ATAG);

const fetchAppointment = L.wrap('()', ({ salonId, appointmentId }) => ({
  ATAG,
  [AUTH_API]: {
    ...authenticatedEndpoint(),
    ...jsonEndpoint(H.get, `salon/${salonId}/appointment/${appointmentId}/`),
    params: { id: appointmentId, appointmentId },
    types: [FETCH_APPOINTMENT_FOR_EDIT_REQUEST, FETCH_APPOINTMENT_FOR_EDIT_SUCCESS, FETCH_APPOINTMENT_FOR_EDIT_FAILURE],
  },
}));

// noinspection JSUnusedGlobalSymbols
export default fetchAppointment;
